export default __webpack_public_path__ + "static/media/btn_explorer.ed338d10.png";